import './index.css'

import cloneDeep from 'lodash/cloneDeep'
import isEqual from 'lodash/isEqual'
import merge from 'lodash/merge'
import React, { useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { updateShortlist } from '@disco/state-management/actions/ShortlistActions'
import { getShortlistById } from '@disco/state-management/selectors/shortlists'

import { getShortlistBaseRoute } from 'utils/routing'

import TextField from 'components/ui/text-field'

import { useDispatch, useSelector } from 'hooks/use-redux'

import PlaylistPresentationSocialLinks from './PlaylistPresentationSocialLinks'

const PlaylistPresentationSocialLinksShortlistContainer =
  (): React.ReactNode => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const { shortlistId } = useParams<{ shortlistId: string }>()
    const shortlist = useSelector(state =>
      getShortlistById(state, {
        id: shortlistId,
      }),
    )
    const showcase = shortlist?.showcase
    const artist = showcase?.artist?.updatedFields || showcase?.artist
    const [links, setLinks] = useState(artist?.social_links || {})
    const [aggregatorLink, setAggregatorLink] = useState(
      artist?.social_links_aggregator || '',
    )

    const onClose = () => {
      const baseRoute = getShortlistBaseRoute(location)
      navigate(`${baseRoute}/shortlists/${shortlistId}/save/presentation`, {
        state: location.state,
      })
    }

    const onSave = () => {
      let linksUpdated = false
      let newShortlist = cloneDeep(shortlist)

      if (aggregatorLink !== showcase?.artist?.social_links_aggregator) {
        linksUpdated = true
      }

      if (!isEqual(links, showcase?.artist?.social_links)) {
        linksUpdated = true
      }

      if (linksUpdated) {
        newShortlist = merge(newShortlist, {
          showcase: {
            artist: {
              updatedFields: {
                social_links_aggregator: aggregatorLink,
                social_links: links,
              },
            },
          },
        })
      }

      if (linksUpdated && shortlistId && newShortlist) {
        dispatch(updateShortlist(shortlistId, newShortlist))
      }

      onClose()
    }

    const renderRow = ({ value, placeholder, getIcon }) => {
      let textFieldValue = links[`${value}`]

      let onChange = event => {
        setLinks({ ...links, [`${value}`]: event.target.value || null })
      }

      if (value === 'social_links_aggregator') {
        textFieldValue = aggregatorLink

        onChange = event => {
          setAggregatorLink(event.target.value || null)
        }
      }

      // TODO: optimization, re-rendering of all fields when changing one
      return (
        <div key={value} className="PlaylistPresentationSocialLinks_Row">
          <TextField
            icon={getIcon('PlaylistPresentationSocialLinks_Icon')}
            placeholder={placeholder}
            type="url"
            value={textFieldValue || ''}
            onChange={onChange}
          />
        </div>
      )
    }

    return (
      <PlaylistPresentationSocialLinks
        onClose={onClose}
        onSave={onSave}
        renderRow={renderRow}
      />
    )
  }

export default PlaylistPresentationSocialLinksShortlistContainer
